import { cleanupFileName } from '../../utils/global/helper';

export const getCustomerFileName = ({
  businessId,
  customerId,
  file,
}: {
  businessId: string;
  customerId: string;
  file: File;
}) => {
  const ext = file.type.split('/')[1];
  const fileName = file.name.split('.')[0];
  const newFileName = `${fileName}.${ext}`;
  return `businesses/${businessId}/customers/${customerId}/${cleanupFileName(
    newFileName,
  )}`;
};
